import { TOGGLE_FEEDBACK_FORM } from "./action";

const initialState = {
    showFeedbackForm: false,
    options: {}
}

export default (state = initialState, action) => {
    const payload = action?.payload;

    switch (action.type) {
        case TOGGLE_FEEDBACK_FORM:
            return {
                ...state, showFeedbackForm: Boolean(payload.show),options: payload.options
            }
        default:
            return state;
    }
}